import * as api from './api';
import isEmpty from 'lodash.isempty';
import { v4 as uuidv4 } from 'uuid';
import Pusher from 'pusher-js';

let pusher;
let channel;
export default {
  getProducts: async ({ commit, dispatch, state, getters }, force) => {
    if (getters.token && (force || isEmpty(state.products))) {
      const products = await api.getProducts(state.credentials);
      commit('SET_PRODUCTS', products);
    }
    dispatch('initPusher');
  },

  getSharedProducts: async ({ commit, state, getters }, productIds) => {
    return await api.getSharedProducts(productIds);
  },

  getMerchantProducts: async ({ commit, state, getters }, credentials) => {
    return await api.getMerchantProducts(credentials);
  },

  getCategories: async ({ commit, state, getters }, force) => {
    if (getters.token && (isEmpty(state.categories) || force)) {
      const categories = await api.getCategories(state.credentials);
      commit('SET_CATEGORIES', categories.categories);
    }
  },

  addProduct: async ({ state, commit, dispatch, getters }, productInfo) => {
    commit('ADD_RPODUCT', productInfo);
    await api.addProduct(productInfo, state.credentials);
    await dispatch('getProducts', { email: getters.email, force: true });
  },

  removeProduct: async ({ commit, state }, id) => {
    commit('REMOVE_PRODUCT', id);
    await api.removeProduct([id], state.credentials);
  },

  removeIframeProduct: async ({ commit }, id) => {
    commit('REMOVE_IFRAME_PRODUCT', id);
  },

  addComment: async ({ commit, state }, comment) => {
    comment.id = uuidv4();
    commit('ADD_COMMENT', comment);
    await api.addComment(comment, state.credentials);
  },

  addReaction: async ({ dispatch, state, commit }, reaction) => {
    reaction.id = uuidv4();
    commit('ADD_REACTION', reaction);
    await api.addReaction(reaction, state.credentials);
  },

  removeReaction: async ({ dispatch, state, commit }, reaction) => {
    commit('REMOVE_REACTION', reaction);
    await api.removeReaction({ id: reaction.id, sharedDataId: reaction.sharedDataId }, state.credentials);
  },

  removeComment: async ({ commit, state }, comment) => {
    commit('REMOVE_COMMENT', comment);
    await api.removeComment(comment, state.credentials);
  },

  editProduct: async ({ commit, dispatch, state }, product) => {
    commit('EDIT_RPODUCT', product);
    await api.editProduct(product, state.credentials);
  },

  registerUser: async ({ commit }, user) => {
    const response = await api.registerUser(user);
    commit('SET_LOGIN_DATA', response.user);
  },

  setCredentials: async ({ commit }, credentials) => {
    commit('SET_LOGIN_DATA', credentials);
  },
  loginUser: async ({ commit, dispatch }, user) => {
    const response = await api.loginUser(user);
    commit('SET_LOGIN_DATA', response.user);
    await dispatch('getProducts', true);
    await dispatch('getCategories', true);
  },

  setLoadingFlag: ({ commit }, flag) => {
    commit('SET_LOADING_FLAG', flag);
  },

  logout: ({ commit }) => {
    commit('CLEAR_STATE');
  },

  addNewCategory: async ({ state, commit }, category) => {
    commit('ADD_NEW_CATEGORY', category);
    await api.addNewCategory(state.categories, state.credentials);
  },

  removeCategory: async ({ state, commit }, category) => {
    commit('REMOVE_CATEGORY', category);
    await api.addNewCategory(state.categories, state.credentials);
  },

  addProductAlarm: async ({ state, commit }, product) => {
    commit('ADD_PRODUCT_ALARM', product.productId);
  },

  removeProductAlarm: async ({ state, commit }, product) => {
    commit('REMOVE_PRODUCT_ALARM', product.productId);
  },

  shareProduct: async ({ state, dispatch, commit }, product) => {
    commit('ADD_SHARE_BY_ME_PRODUCT', product);
    await api.shareProduct(product, state.credentials);
  },
  initPusher: ({ dispatch, getters }) => {
    if (!pusher) {
      const channelName = `${getters.email}-channel`;
      pusher = new Pusher('ca4ea6a2e4004291d72b', {
        cluster: 'mt1',
      });

      channel = pusher.subscribe(channelName);
      pusher.channel(channelName).bind_global((event, data) => dispatch('onPusherEvent', { event, data }));
    }
  },

  getProductsAlarms: ({ commit }) => {
    commit('INIT_PRODUCT_ALARMS');
  },

  onPusherEvent: ({ dispatch }, { event, data }) => {
    switch (event) {
      case 'remove-product':
        dispatch('getProducts', true);
        break;
      case 'add-product':
        dispatch('getProducts', true);
        break;
      case 'price-changed':
        dispatch('getProducts', true);
        break;
      case 'move-product-to-category':
        dispatch('getProducts', true);
        break;
      case 'edit-category':
        dispatch('getCategories', true);
        break;
      case 'add-like':
        dispatch('getProducts', true);
        // dispatch('getSharedProducts', true);
        break;
      case 'remove-like':
        dispatch('getProducts', true);
        // dispatch('getSharedProducts', true);
        break;
      case 'add-comment':
        dispatch('getProducts', true);
        // dispatch('getSharedProducts', true);
        break;
      case 'remove-comment':
        dispatch('getProducts', true);
        // dispatch('getSharedProducts', true);
        break;
      case 'share-product':
        dispatch('getProducts', true);
      // dispatch('getSharedProducts', true);
    }

    console.log(JSON.stringify(event));
    console.log(JSON.stringify(data));
  },

  addBanner: ({ commit }, options) => {
    // Set Default Options
    options.sm = !!options.sm;
    options.type = options.type || 'success';
    options.time = options.time || 5000;
    options.dismiss = options.dismiss || false;
    options.id = new Date().getTime(); // Using the current time as a unique key for the message
    options.ellipsis = options.ellipsis && true;

    commit('ADD_BANNER', options);
  },

  removeBanner: ({ commit }, options) => commit('REMOVE_BANNER', options),


  addListIdToUser: async ({ state }, listId) => {
    await api.addListIdToUser(state.credentials, listId);
  },

  setIframeFlag: ({ commit }, flag) => {
    commit('SET_IFRAME_FLAG', flag)
  },

  setIframeProducts: ({ commit }, products) => {
    commit('SET_IFRAME_PRODUCTS', products)
  },

  setIframeParentUrl: ({ commit }, merchantUrl) => {
    commit('SET_IFRAME_PARENT_URL', merchantUrl)
  },



};
